import React, { useEffect, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";

import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import userService from "../services/users-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
const tablePropsInit = {
  columns: [
    { key: "firstName", title: "First Name" },
    { key: "lastName", title: "Last Name" },
    { key: "email", title: "Email" },
    { key: "phone", title: "Phone Number" },
    { key: "facilityName", title: "Facility / Department" },
    { key: "department", style: { display: "none" } },
    { key: "userRole", title: "Role" },
    { key: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "userId",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const UsersList = ({ history }) => {
  const [loading, setLoading] = useState(false);
  const deactivateUser = async (id, fid, deptid, blocked, event) => {
    let userDet = {
      userId: id,
      facility: fid,
      department: deptid,
    };
    let currentStatus = "";
    if (blocked) {
      userDet.blocked = false;
      currentStatus = "Activate";
    } else {
      userDet.blocked = true;
      currentStatus = "Deactivate";
    }
    if (window.confirm("Are you sure to " + currentStatus + " Account ?")) {
      setLoading(true);
      await userService.updateUser(userDet);
      setLoading(false);
      const { hide } = cogoToast.success(
        "Account " + currentStatus + "d Successfully",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      await history.push("/users");
    }
  };
  const CustomCell = ({ rowData }) => {
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          <Link to={`edit-user/${rowData.userId}`}>
            <img src="/img/edit_icon.svg" className="mt-1 w-4 h-4" alt="logo" />
          </Link>
        </span>
        <span className="inline-block">
          {rowData.blocked ? (
            <>
              <img
                src="./img/inactive.svg"
                className="w-4 h-4"
                alt="delete"
                title="Activate"
                onClick={(e) => {
                  deactivateUser(
                    rowData.userId,
                    rowData.facility,
                    rowData.department,
                    rowData.blocked,
                    e
                  );
                }}
              />
            </>
          ) : (
            <>
              <img
                src="./img/active.svg"
                className="w-4 h-4"
                alt="delete"
                title="Deactivate"
                onClick={(e) => {
                  deactivateUser(
                    rowData.userId,
                    rowData.facility,
                    rowData.department,
                    rowData.blocked,
                    e
                  );
                }}
              />
            </>
          )}
        </span>
      </div>
    );
  };
  const CustomCell1 = ({ rowData }) => {
    return (
      <div>
        {rowData?.userRole
          ? rowData.userRole.replace(/_/g, " ")
          : rowData.userRole}
      </div>
    );
  };
  const CustomCell2 = ({ rowData }) => {
    return (
      <div>
        {rowData?.facility
          ? rowData.userRole !== "PORTAL_ADMIN"
            ? rowData.facilityName
            : "NONE"
          : (rowData.department || "").replace(/_/g, " ")}
      </div>
    );
  };
  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await userService.getUsers();
      resp.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };
  useEffect(() => {}, []);

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">USERS</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4 mb-2 right-5 top-1 bottom-3"
              ></img>
            </span>
            <span className="mr-3">
              <Link
                to="/create-user"
                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
              >
                ADD USER
              </Link>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                    case "userRole":
                      return <CustomCell1 {...props} />;
                    case "facilityName":
                      return <CustomCell2 {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(UsersList)
);
